import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#132A4E] px-6 text-center">
      
      <h1 className="text-8xl font-bold text-white mb-4">
        404
      </h1>

      <h2 className="text-2xl font-semibold text-white mb-3">
        Page Not Found
      </h2>

      <p className="text-gray-200 max-w-md mb-8">
        The page you are looking for might have been removed, renamed,
        or is temporarily unavailable.
      </p>

      <button
        onClick={() => navigate("/")}
        className="bg-white text-[#0A1F8F] px-6 py-3 rounded-lg font-semibold hover:bg-gray-200 transition"
      >
        Go Back Home
      </button>

    </div>
  );
};

export default NotFound;